import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    Show,
    SimpleShowLayout,
    DateField,
    ReferenceField
} from 'react-admin';

export const OrganizationList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ReferenceField source="ParentId" reference="Organization" label="上级组织">
                <TextField source="Name" />
            </ReferenceField>
            <TextField source="Name" label="组织名称" />
            <TextField source="Leader" label="负责人" />
            <TextField source="ContactPhone" label="联系电话" />
            <DateField source="CreateTime" label="创建时间" />
            <EditButton />
        </Datagrid>
    </List>
);

export const OrganizationEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="组织名称" />
            <ReferenceInput source="ParentId" reference="Organization" label="上级组织">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <TextInput source="Leader" label="负责人" />
            <TextInput source="ContactPhone" label="联系电话" />
            <TextInput multiline source="Description" label="描述" />
        </SimpleForm>
    </Edit>
);

export const OrganizationCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="Name" label="组织名称" />
            <ReferenceInput source="ParentId" reference="Organization" label="上级组织">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <TextInput source="Leader" label="负责人" />
            <TextInput source="ContactPhone" label="联系电话" />
            <TextInput multiline source="Description" label="描述" />
        </SimpleForm>
    </Create>
);
